const rawTranslations = {
  EN: {
    nav: { fleet: "Fleet", rental: "Car Rental", services: "VIP Services", how: "How It Works", about: "About", contact: "Contact", admin: "Admin", allCars: "All Cars →", rentPrefix: "Rent" },
    seo: {
      homeTitle: "Luxury Car Rental Dubai | Silver Drive",
      homeDesc: "Rent a Ferrari, Lamborghini, Rolls-Royce or Bentley in Dubai. Free delivery, no deposit, full insurance and 24/7 concierge. Book your luxury car rental in minutes.",
      homeKeywords: "rent a car dubai, luxury car rental dubai, supercar rental dubai, exotic car rental dubai, rent a ferrari dubai, rent a lamborghini dubai, rent a rolls royce dubai, rent a bentley dubai",
      heroAlt: "Silver Drive ultra-luxury car fleet in Dubai",
      altSuffix: "for rent in Dubai",
      carKwTpl: "rent {name} dubai, {brand} rental dubai, hire {name} dubai, luxury car rental dubai",
      catKwTpl: "{name} rental dubai, rent {name} dubai, luxury {name} hire dubai, {name} car rental dubai",
      detailTitleTpl: "Rent {name} Dubai | Silver Drive",
      detailDescTpl: "Rent the {name} in Dubai from {price}/day. Free delivery, no deposit, full insurance and 24/7 concierge. Book online with Silver Drive.",
      galleryAltTpl: "{name} — photo {n}, luxury car rental in Dubai",
    },
    hero: {
      eyebrow: "Dubai • Ultra-Luxury Rental Concierge",
      title: "Command The Road In Absolute Luxury",
      subtitle: "From Ferrari to Rolls-Royce, Lamborghini to Bentley — Silver Drive delivers the world's most coveted machines to your doorstep in Dubai.",
      exploreFleet: "Explore The Fleet",
      instantBooking: "Instant Booking",
      noDeposit: "No Deposit", noDepositSub: "Zero security deposit",
      freeDelivery: "Free Delivery", freeDeliverySub: "Anywhere in Dubai",
      dreamLine1: "YOUR DREAM CAR",
      dreamGold: "IN DUBAI",
      dreamLine3: "IS WAITING FOR YOU",
      tagline2: "Rent. Drive. Discover. Don't settle for ordinary — live the extraordinary.",
      bookNow: "BOOK NOW",
      features: [
        { title: "Premium Fleet", sub: "Handpicked hypercars" },
        { title: "No Deposit", sub: "Zero security deposit" },
        { title: "Free Delivery", sub: "Anywhere in Dubai" },
        { title: "24/7 Support", sub: "Always at your side" },
        { title: "VIP Experience", sub: "White-glove service" }
      ],
      stat1: "Hypercars", stat2: "VIP Concierge", stat3: "Deposit Options",
    },
    fleet: {
      title: "The Collection",
      subtitle: "A hand-curated fleet of hypercars, supercars and ultra-luxury vehicles.",
      all: "All", allSuppliers: "All Suppliers", viewAll: "View all →", perDay: "/ day", viewDetails: "View & Book", available: "Available", booked: "Booked", maintenance: "Maintenance",
    },
    detail: {
      back: "Back to Fleet", specifications: "Specifications", engine: "Engine", horsepower: "Power",
      acceleration: "0-100 km/h", topSpeed: "Top Speed", transmission: "Transmission", seats: "Seats", dailyKmLimit: "Daily mileage limit",
      dailyRate: "Daily Rate", requestBooking: "Request This Vehicle", startDate: "Start Date", endDate: "End Date",
      firstName: "First Name", lastName: "Last Name", phone: "Phone Number", note: "Note (optional)",
      submit: "Submit Booking Request", estimated: "Estimated Total", days: "days",
      successTitle: "Request Received", successMsg: "Our VIP concierge will contact you shortly to confirm your reservation.",
      selectDates: "Please select your rental dates.", notFound: "Vehicle not found.",
      unavailableTitle: "Unavailable dates", datesUnavailable: "Those dates are already booked. Please choose another range.",
      currentlyBooked: "Currently rented out",
      pickDates: "Select rental dates", clearDates: "Clear",
      deliveryQuestion: "How would you like to receive the car?",
      deliveryOption: "Deliver it to me", pickupOption: "I'll pick it up from your location",
      deliveryLocation: "Delivery location / hotel / address", deliveryLocationPh: "e.g. Atlantis The Palm, Dubai",
      phonePlaceholder: "50 123 45 67", countryCode: "Country",
    },
    showcase: [
      { brand: "Lamborghini", model: "Revuelto", tagline: "For grander journeys" },
      { brand: "Ferrari", model: "F8 Tributo", tagline: "Passion on every road" },
      { brand: "McLaren", model: "720S", tagline: "Where performance meets freedom" }
    ],
    home: {
      brandTitle: "Browse by Brand",
      brandSub: "Choose from the world's most prestigious automotive marques.",
      whatsappCta: "Book on WhatsApp",
      aiChatCta: "AI Concierge",
      featuredTitle: "Featured This Week",
      featuredSubtitle: "Our most sought-after vehicles, ready for immediate delivery.",
      showMore: "Show more",
      showLess: "Show less",
      popularModels: "Popular Models to Rent in Dubai",
      catTitle: "Explore by Category",
      catSub: "From executive sedans to exotic supercars, find the perfect vehicle for any occasion.",
      categories: [
        { title: "Luxury Sedans", sub: "Rolls-Royce, Bentley, Mercedes-Maybach" },
        { title: "Premium SUVs", sub: "Lamborghini Urus, Range Rover, G63" },
        { title: "Convertibles", sub: "Open-top driving for coastal roads" },
        { title: "Sports Cars", sub: "Ferrari, McLaren, Porsche" }
      ],
      revTitle: "What our guests say",
      revSub: "Real experiences from clients across Dubai & the UAE.",
      reviews: [
        { name: "Dave R.", car: "Ferrari F8", text: "Delivered to my hotel within 30 minutes. The team were extremely helpful and professional. Highly recommend." },
        { name: "Mamadou W.", car: "Range Rover SVR", text: "Incredible experience — every car spotless, powerful and exactly as promised. Delivery and pickup on time." },
        { name: "Val M.", car: "Lamborghini Huracan", text: "Used them several times and they never disappoint. Great cars and outstanding customer service." }
      ],
      whyTitle: "Why Dubai rents with Silver Drive",
      why: [
        "Licensed luxury rental operator serving Dubai & the UAE",
        "One of the largest exotic fleets — Ferrari, Lamborghini, Rolls-Royce, Bentley",
        "Transparent daily rates with zero hidden charges",
        "Open 24/7 with instant booking and full insurance",
        "No Deposit Options",
        "Free delivery & collection across the Emirates"
      ],
      waysTitle: "Ways to drive with Silver Drive",
      ways: [
        "Self-drive rentals by the day, week or month",
        "Chauffeur service for airport transfers & events",
        "Wedding, photoshoot & corporate packages",
        "Delivery across Dubai, Abu Dhabi, Sharjah & RAK"
      ],
      stepsTitle: "How to Book Your Luxury Car",
      stepsSub: "Reserve in minutes — delivered to your door, often within 60 minutes.",
      steps: [
        "Browse the live fleet and compare models, specs & rates",
        "Reserve in seconds via the booking form",
        "Share a valid driving licence and Emirates ID or passport",
        "Choose delivery to your hotel, residence or any UAE airport",
        "Get your car delivered, often within 60 minutes"
      ],
      faqTitle: "Frequently Asked Questions",
      faq: [
        { q: "How do I rent a car in Dubai as a tourist?", a: "Choose your car and dates, then submit the booking request. We confirm availability, total cost and required documents, then deliver free to your hotel or any UAE airport — usually within 60 minutes." },
        { q: "What documents are required?", a: "A valid driving licence accepted in the UAE, a passport copy, and a credit card. UAE residents can provide an Emirates ID; some visitors may need an International Driving Permit." },
        { q: "Is a security deposit required?", a: "A rental option without a security deposit is available." },
        { q: "Are there age restrictions?", a: "Drivers must be at least 21 for most luxury vehicles and 25+ for select supercars. We confirm eligibility during booking." },
        { q: "Do you deliver to hotels and the airport?", a: "Yes — complimentary delivery and collection across Dubai, including major hotels, Dubai Marina, Downtown and both airports, 24/7." }
      ]
    },
    footer: { tagline: "Dubai's premier ultra-luxury car rental atelier.", rights: "All rights reserved.", address: "Sheikh Zayed Road, Dubai, UAE", concierge: "24 / 7 VIP Concierge", deliveryNote: "Delivery across Dubai, Abu Dhabi & the Emirates." },
    lead: {
      title: "Let us call you back", sub: "Leave your number and we'll call within minutes with our best rate.",
      call: "Call", callMe: "Call me", namePh: "Your name", phonePh: "Your phone",
      success: "Thank you! Our team will call you back shortly.", validate: "Please enter your name and phone", got: "Got it! We'll call you shortly.",
    },
    category: {
      popularTitle: "Popular Categories",
      popularSub: "Find your perfect drive by category — from track-bred exotics to commanding luxury SUVs.",
      explore: "Explore",
      available: "Available to Rent in Dubai",
      faqTitle: "Frequently Asked Questions",
      reserve: "Reserve your {name} today",
      reserveSub: "Free delivery across Dubai • No deposit • 24/7 concierge",
      ratesFrom: "Rates from",
      perDay: "/day",
      emptyMsg: "New {name} are arriving soon. Contact our concierge for current availability.",
      benefits: ["Free delivery across Dubai", "No cash deposit required", "Comprehensive insurance included", "24/7 concierge support", "Flexible daily, weekly & monthly rates"],
      faqs: [
        { q: "How much does {name} rental cost in Dubai?", a: "Renting with Silver Drive starts from AED {price} per day, with discounted weekly and monthly rates. Every rate includes comprehensive insurance and free delivery across Dubai." },
        { q: "Is a deposit required?", a: "No cash deposit is required. We only place a fully refundable pre-authorisation on your card for the duration of the rental." },
        { q: "Can you deliver the car to my hotel or the airport?", a: "Yes — Silver Drive offers complimentary delivery and collection anywhere in Dubai, 24/7, including all UAE airports." },
        { q: "What documents do I need?", a: "UAE residents need a valid UAE driving licence and Emirates ID. Visitors need a passport, home-country licence and an International Driving Permit." },
        { q: "Can I rent for a longer period?", a: "Absolutely. We offer flexible daily, weekly and monthly rates — the longer the rental, the better the daily price. Just ask our concierge." },
      ],
    },
    admin: {
      login: "Admin Login", email: "Email", password: "Password", signIn: "Sign In",
      dashboard: "Dashboard", cars: "Fleet", requests: "Requests", settings: "Settings", logout: "Logout",
      totalRequests: "Total Requests", fleetCount: "Fleet Vehicles", activeRentals: "Active Rentals",
      revenue: "Completed Revenue", newRequests: "New Requests",
      revenueLabel: "Revenue", costLabel: "Cost", profitLabel: "Profit", margin: "Margin",
      allReservations: "All Reservations", completedReservations: "Completed Reservations",
      cost: "Cost / day (AED)", profitPerDay: "Profit / day", calendarTitle: "Availability Calendar",
      bookedDay: "Booked", freeDay: "Free", noFinance: "No completed reservations yet.",
      addCar: "Add Vehicle", editCar: "Edit Vehicle", deleteCar: "Delete", save: "Save", cancel: "Cancel",
      name: "Name", brand: "Brand", category: "Category", status: "Status", source: "Supplier", price: "Daily Price (AED)",
      customer: "Customer", vehicle: "Vehicle", dates: "Dates", total: "Total", actions: "Actions",
      noRequests: "No booking requests yet.",
      availability: "Availability", manageAvailability: "Manage Availability",
      selectVehicle: "Select a vehicle to manage its booked dates.",
      busyPeriods: "Booked Periods", addPeriod: "Mark as Booked",
      noPeriods: "No booked periods. This vehicle is fully available.",
      from: "From", to: "To", labelField: "Label (e.g. customer name)",
      blockDates: "Block dates", availableNow: "Available", bookedNow: "Booked",
      engine: "Engine", horsepower: "Horsepower", acceleration: "0-100 km/h", topSpeed: "Top Speed", transmission: "Transmission", seats: "Seats",
      mainImage: "Main Image", changeMainImage: "Change main image", selectMainImage: "Select main image", pleaseMainImage: "Please upload a main image",
      galleryImages: "Gallery Images", addGalleryImages: "Add gallery images", uploading: "Uploading…",
      descEn: "Description (EN)", descTr: "Description (TR)", descRu: "Description (RU)", modelYear: "Model Year", model: "Model", dailyKmLimit: "Daily km limit",
      selectBrand: "Select brand", selectModel: "Select model", chooseBrandFirst: "Choose a brand first", selectYear: "Select year",
      edit: "Edit", vehicles: "vehicles", deleteConfirm: "Delete this vehicle?",
      discounts: "Long-rental Discounts", discountsSub: "Auto-discount the customer price for longer rentals (cost stays the same).", minDays: "Min days", percentOff: "% off", addRule: "Add rule", saveDiscounts: "Save discounts", noDiscounts: "No discount rules — full daily rate applies.",
      topCars: "Most Profitable Cars", monthlyTrend: "Monthly Revenue & Profit", noAnalytics: "No completed reservations to chart yet.", discountApplied: "discount applied",
      downloadPdf: "Download quote (PDF)",
      sales: "Confirmed Sales",
      salesCount: "confirmed sales",
      addExternalSale: "Add external sale",
      exportSalesExcel: "Export Excel",
      salesExcelReady: "Confirmed Sales Excel is ready.",
      entryCost: "Entry cost",
      salePrice: "Sale price",
      profit: "Profit",
      documents: "Documents",
      uploadDoc: "Upload PDF / image",
      noSales: "No confirmed sales yet.",
      locked: "Admin edits only",
      editSale: "Edit sale",
      approveTitle: "Confirm this sale",
      approveSub: "Enter the entry cost and sale price. Only administrators can change saved values.",
      confirmSale: "Confirm sale",
      externalTag: "External",
      requestTag: "From request",
      customerName: "Customer",
      vehicleName: "Vehicle",
      saveSale: "Save",
      deleteSaleConfirm: "Delete this confirmed sale?",
      deleteDocumentConfirm: "Delete this document?",
    },
    legal: {
      privacy: "Privacy Policy",
      rental: "Rental Conditions",
      consentPre: "I have read and accept the",
      consentAnd: "and the",
      consentRequired: "Please accept the Rental Conditions and Privacy Policy to continue.",
    },
    quick: {
      reserve: "Quick reserve",
      title: "Quick reservation",
      start: "Start date",
      end: "End date",
      name: "Full name",
      phone: "Phone",
      phoneCountry: "Country / dialing code",
      requestDestination: "Your request is sent to the management panel's Requests section.",
      submit: "Send request",
    },
  },
  TR: {
    nav: { fleet: "Filo", rental: "Araç Kiralama", services: "VIP Hizmetler", how: "Nasıl Çalışır", about: "Hakkımızda", contact: "İletişim", admin: "Yönetim", allCars: "Tüm Araçlar →", rentPrefix: "Kirala" },
    seo: {
      homeTitle: "Dubai Lüks Araç Kiralama | Silver Drive",
      homeDesc: "Dubai'de Ferrari, Lamborghini, Rolls-Royce veya Bentley kiralayın. Ücretsiz teslimat, depozito yok, tam sigorta ve 7/24 concierge. Lüks araç kiralamanızı dakikalar içinde yapın.",
      homeKeywords: "dubai araç kiralama, dubai lüks araç kiralama, dubai süper araç kiralama, dubai egzotik araç kiralama, dubai ferrari kiralama, dubai lamborghini kiralama, dubai rolls royce kiralama, dubai bentley kiralama",
      heroAlt: "Dubai'de Silver Drive lüks araç filosu",
      altSuffix: "Dubai'de kiralık",
      carKwTpl: "{name} kiralama dubai, {brand} kiralama dubai, dubai {name} kirala, dubai lüks araç kiralama",
      catKwTpl: "{name} kiralama dubai, dubai {name} kirala, dubai lüks {name} kiralama, {name} araç kiralama dubai",
      detailTitleTpl: "Dubai'de {name} Kiralama | Silver Drive",
      detailDescTpl: "{name} aracını Dubai'de günlük {price}'den kiralayın. Ücretsiz teslimat, depozito yok, tam sigorta ve 7/24 concierge. Silver Drive ile online rezervasyon yapın.",
      galleryAltTpl: "{name} — fotoğraf {n}, Dubai lüks araç kiralama",
    },
    hero: {
      eyebrow: "Dubai • Ultra-Lüks Kiralama Konsiyerji",
      title: "Yolları Mutlak Lüksle Fethedin",
      subtitle: "Ferrari'den Rolls-Royce'a, Lamborghini'den Bentley'e — Silver Drive dünyanın en gözde araçlarını Dubai'de kapınıza getirir.",
      exploreFleet: "Filoyu Keşfet",
      instantBooking: "Hemen Rezervasyon",
      noDeposit: "Depozito Yok", noDepositSub: "Sıfır güvence bedeli",
      freeDelivery: "Ücretsiz Teslimat", freeDeliverySub: "Dubai'nin her yerine",
      dreamLine1: "HAYALİNDEKİ ARABA",
      dreamGold: "DUBAI'DE",
      dreamLine3: "SENİ BEKLİYOR",
      tagline2: "Kirala. Sür. Keşfet. Sıradan değil, olağanüstüyü yaşa.",
      bookNow: "HEMEN KİRALA",
      features: [
        { title: "Premium Filo", sub: "Seçkin hiper otomobiller" },
        { title: "Depozito Yok", sub: "Sıfır güvence bedeli" },
        { title: "Ücretsiz Teslimat", sub: "Dubai'nin her yerine" },
        { title: "7/24 Destek", sub: "Her an yanınızda" },
        { title: "VIP Deneyim", sub: "Kusursuz hizmet" }
      ],
      stat1: "Hiper Otomobil", stat2: "VIP Konsiyerj", stat3: "Depozito Seçeneği",
    },
    fleet: {
      title: "Koleksiyon",
      subtitle: "Özenle seçilmiş hiper otomobiller, süper otomobiller ve ultra-lüks araçlardan oluşan filo.",
      all: "Tümü", allSuppliers: "Tüm Tedarikçiler", viewAll: "Tümünü gör →", perDay: "/ gün", viewDetails: "İncele & Kirala", available: "Müsait", booked: "Dolu", maintenance: "Bakımda",
    },
    detail: {
      back: "Filoya Dön", specifications: "Teknik Özellikler", engine: "Motor", horsepower: "Güç",
      acceleration: "0-100 km/s", topSpeed: "Azami Hız", transmission: "Şanzıman", seats: "Koltuk", dailyKmLimit: "Günlük kilometre limiti",
      dailyRate: "Günlük Ücret", requestBooking: "Bu Aracı Talep Et", startDate: "Başlangıç Tarihi", endDate: "Bitiş Tarihi",
      firstName: "Ad", lastName: "Soyad", phone: "Telefon Numarası", note: "Not (isteğe bağlı)",
      submit: "Rezervasyon Talebi Gönder", estimated: "Tahmini Toplam", days: "gün",
      successTitle: "Talebiniz Alındı", successMsg: "VIP konsiyerjimiz rezervasyonunuzu onaylamak için kısa süre içinde sizinle iletişime geçecek.",
      selectDates: "Lütfen kiralama tarihlerinizi seçin.", notFound: "Araç bulunamadı.",
      unavailableTitle: "Müsait olmayan tarihler", datesUnavailable: "Seçtiğiniz tarihler dolu. Lütfen başka bir aralık seçin.",
      currentlyBooked: "Şu anda kirada",
      pickDates: "Kiralama tarihlerini seçin", clearDates: "Temizle",
      deliveryQuestion: "Aracı nasıl teslim almak istersiniz?",
      deliveryOption: "Bana teslim edin", pickupOption: "Teslim noktanızdan alacağım",
      deliveryLocation: "Teslimat konumu / otel / adres", deliveryLocationPh: "örn. Atlantis The Palm, Dubai",
      phonePlaceholder: "532 123 45 67", countryCode: "Ülke",
    },
    showcase: [
      { brand: "Lamborghini", model: "Revuelto", tagline: "Daha büyük yolculuklar için" },
      { brand: "Ferrari", model: "F8 Tributo", tagline: "Her yolda tutkuyla" },
      { brand: "McLaren", model: "720S", tagline: "Performans özgürlükle buluşur" }
    ],
    home: {
      brandTitle: "Markaya Göre Keşfet",
      brandSub: "Dünyanın en prestijli otomobil markalarından seçin.",
      whatsappCta: "WhatsApp'tan Rezervasyon",
      aiChatCta: "Yapay Zekâ Asistan",
      featuredTitle: "Bu Haftanın Öne Çıkanları",
      featuredSubtitle: "En çok tercih edilen araçlarımız, anında teslime hazır.",
      showMore: "Daha fazla göster",
      showLess: "Daha az göster",
      popularModels: "Dubai'de Kiralık Popüler Modeller",
      catTitle: "Kategoriye Göre Keşfet",
      catSub: "Yönetici sedanlarından egzotik süper otomobillere, her ana uygun aracı bulun.",
      categories: [
        { title: "Lüks Sedanlar", sub: "Rolls-Royce, Bentley, Mercedes-Maybach" },
        { title: "Premium SUV'lar", sub: "Lamborghini Urus, Range Rover, G63" },
        { title: "Üstü Açıklar", sub: "Sahil yolları için açık tavan keyfi" },
        { title: "Spor Otomobiller", sub: "Ferrari, McLaren, Porsche" }
      ],
      revTitle: "Misafirlerimiz ne diyor",
      revSub: "Dubai ve BAE genelindeki müşterilerimizin gerçek deneyimleri.",
      reviews: [
        { name: "Dave R.", car: "Ferrari F8", text: "Otelime 30 dakika içinde teslim edildi. Ekip son derece yardımcı ve profesyoneldi. Şiddetle tavsiye ederim." },
        { name: "Mamadou W.", car: "Range Rover SVR", text: "İnanılmaz bir deneyim — her araç tertemiz, güçlü ve tam söz verildiği gibi. Teslimat ve alım zamanındaydı." },
        { name: "Val M.", car: "Lamborghini Huracan", text: "Defalarca kullandım ve hiç hayal kırıklığına uğratmadılar. Harika araçlar, mükemmel müşteri hizmeti." }
      ],
      whyTitle: "Dubai neden Silver Drive'ı seçiyor",
      why: [
        "Dubai ve BAE'ye hizmet veren lisanslı lüks kiralama operatörü",
        "En geniş egzotik filolardan biri — Ferrari, Lamborghini, Rolls-Royce, Bentley",
        "Gizli ücret olmadan şeffaf günlük fiyatlar",
        "7/24 açık, anında rezervasyon ve tam sigorta",
        "Depozito Seçeneği Yok",
        "Emirlikler genelinde ücretsiz teslimat ve alım"
      ],
      waysTitle: "Silver Drive ile sürüş seçenekleri",
      ways: [
        "Günlük, haftalık veya aylık kendin sür kiralama",
        "Havalimanı transferi ve etkinlikler için şoförlü hizmet",
        "Düğün, fotoğraf çekimi ve kurumsal paketler",
        "Dubai, Abu Dabi, Şarjah ve RAK'a teslimat"
      ],
      stepsTitle: "Lüks Aracınızı Nasıl Kiralarsınız",
      stepsSub: "Dakikalar içinde rezervasyon — çoğu zaman 60 dakika içinde kapınızda.",
      steps: [
        "Canlı filoyu inceleyin, modelleri, özellikleri ve fiyatları karşılaştırın",
        "Rezervasyon formuyla saniyeler içinde ayırtın",
        "Geçerli ehliyet ve Emirates ID veya pasaport paylaşın",
        "Otelinize, evinize veya herhangi bir BAE havalimanına teslimat seçin",
        "Aracınız genellikle 60 dakika içinde teslim edilir"
      ],
      faqTitle: "Sıkça Sorulan Sorular",
      faq: [
        { q: "Turist olarak Dubai'de nasıl araç kiralarım?", a: "Aracınızı ve tarihleri seçin, ardından rezervasyon talebini gönderin. Müsaitliği, toplam ücreti ve gerekli belgeleri onaylar, sonra otelinize veya herhangi bir BAE havalimanına ücretsiz teslim ederiz — genellikle 60 dakika içinde." },
        { q: "Hangi belgeler gereklidir?", a: "BAE'de geçerli bir ehliyet, pasaport kopyası ve kredi kartı. BAE sakinleri Emirates ID verebilir; bazı ziyaretçilerin Uluslararası Sürüş İzni gerekebilir." },
        { q: "Depozito gerekli mi?", a: "Kiralamalarda depozit olmadan kiralama seçeneği bulunmaktadır." },
        { q: "Yaş sınırı var mı?", a: "Sürücüler çoğu lüks araç için en az 21, seçili süper otomobiller için 25+ olmalıdır. Uygunluğu rezervasyon sırasında onaylarız." },
        { q: "Otele ve havalimanına teslimat var mı?", a: "Evet — Dubai genelinde büyük oteller, Dubai Marina, Downtown ve her iki havalimanı dahil ücretsiz teslimat ve alım, 7/24." }
      ]
    },
    footer: { tagline: "Dubai'nin önde gelen ultra-lüks araç kiralama ateliyesi.", rights: "Tüm hakları saklıdır.", address: "Sheikh Zayed Road, Dubai, BAE", concierge: "7/24 VIP Konsiyerj", deliveryNote: "Dubai, Abu Dabi ve Emirlikler geneli teslimat." },
    lead: {
      title: "Hemen sizi arayalım", sub: "Numaranızı bırakın, dakikalar içinde arayıp en iyi fiyatı verelim.",
      call: "Ara", callMe: "Beni Ara", namePh: "Adınız Soyadınız", phonePh: "Telefon numaranız",
      success: "Teşekkürler! Ekibimiz sizi kısa sürede arayacak.", validate: "Lütfen ad ve telefon girin", got: "Talebiniz alındı! Sizi hemen arayacağız.",
    },
    category: {
      popularTitle: "Popüler Kategoriler",
      popularSub: "Kategorilere göre mükemmel aracınızı bulun — pistten türetilmiş egzotiklerden heybetli lüks SUV'lara.",
      explore: "Keşfet",
      available: "Dubai'de Kiralık",
      faqTitle: "Sıkça Sorulan Sorular",
      reserve: "{name} aracınızı bugün ayırtın",
      reserveSub: "Dubai geneli ücretsiz teslimat • Depozito yok • 7/24 concierge",
      ratesFrom: "Fiyatlar",
      perDay: "/gün",
      emptyMsg: "Yeni araçlar çok yakında geliyor. Güncel müsaitlik için concierge ekibimizle iletişime geçin.",
      benefits: ["Dubai geneli ücretsiz teslimat", "Nakit depozito gerekmez", "Kapsamlı sigorta dahil", "7/24 concierge desteği", "Esnek günlük, haftalık ve aylık fiyatlar"],
      faqs: [
        { q: "Dubai'de {name} kiralamak ne kadar?", a: "Silver Drive ile kiralama günlük AED {price}'den başlar; haftalık ve aylık indirimli fiyatlar mevcuttur. Tüm fiyatlara kapsamlı sigorta ve Dubai geneli ücretsiz teslimat dahildir." },
        { q: "Depozito gerekiyor mu?", a: "Nakit depozito gerekmez. Yalnızca kiralama süresince kartınıza tamamen iade edilebilir bir ön provizyon uygulanır." },
        { q: "Aracı otelime veya havalimanına teslim eder misiniz?", a: "Evet — Silver Drive, tüm BAE havalimanları dahil Dubai'nin her yerine 7/24 ücretsiz teslimat ve alım sunar." },
        { q: "Hangi belgeler gerekli?", a: "BAE sakinleri geçerli BAE ehliyeti ve Emirates ID'ye ihtiyaç duyar. Ziyaretçiler pasaport, kendi ülke ehliyeti ve Uluslararası Sürüş İzni gerektirir." },
        { q: "Daha uzun süre kiralayabilir miyim?", a: "Kesinlikle. Esnek günlük, haftalık ve aylık fiyatlar sunuyoruz — kiralama ne kadar uzun olursa günlük fiyat o kadar iyi olur. Concierge ekibimize sorun." },
      ],
    },
    admin: {
      login: "Yönetim Girişi", email: "E-posta", password: "Şifre", signIn: "Giriş Yap",
      dashboard: "Panel", cars: "Filo", requests: "Talepler", settings: "Ayarlar", logout: "Çıkış",
      totalRequests: "Toplam Talep", fleetCount: "Filo Aracı", activeRentals: "Aktif Kiralama",
      revenue: "Tamamlanan Gelir", newRequests: "Yeni Talep",
      revenueLabel: "Ciro", costLabel: "Maliyet", profitLabel: "Kâr", margin: "Marj",
      allReservations: "Tüm Rezervasyonlar", completedReservations: "Tamamlanan Rezervasyonlar",
      cost: "Geliş Maliyeti (AED/gün)", profitPerDay: "Kâr / gün", calendarTitle: "Müsaitlik Takvimi",
      bookedDay: "Dolu", freeDay: "Boş", noFinance: "Henüz tamamlanan rezervasyon yok.",
      addCar: "Araç Ekle", editCar: "Aracı Düzenle", deleteCar: "Sil", save: "Kaydet", cancel: "İptal",
      name: "Ad", brand: "Marka", category: "Kategori", status: "Durum", source: "Tedarikçi", price: "Günlük Fiyat (AED)",
      customer: "Müşteri", vehicle: "Araç", dates: "Tarihler", total: "Toplam", actions: "İşlemler",
      noRequests: "Henüz rezervasyon talebi yok.",
      availability: "Müsaitlik", manageAvailability: "Müsaitlik Yönetimi",
      selectVehicle: "Dolu tarihlerini yönetmek için bir araç seçin.",
      busyPeriods: "Dolu Dönemler", addPeriod: "Dolu Olarak İşaretle",
      noPeriods: "Dolu dönem yok. Bu araç tamamen müsait.",
      from: "Başlangıç", to: "Bitiş", labelField: "Etiket (örn. müşteri adı)",
      blockDates: "Tarihleri kapat", availableNow: "Müsait", bookedNow: "Dolu",
      engine: "Motor", horsepower: "Beygir Gücü", acceleration: "0-100 km/s", topSpeed: "Azami Hız", transmission: "Şanzıman", seats: "Koltuk",
      mainImage: "Ana Görsel", changeMainImage: "Ana görseli değiştir", selectMainImage: "Ana görsel seç", pleaseMainImage: "Lütfen bir ana görsel yükleyin",
      galleryImages: "Galeri Görselleri", addGalleryImages: "Galeri görseli ekle", uploading: "Yükleniyor…",
      descEn: "Açıklama (EN)", descTr: "Açıklama (TR)", descRu: "Açıklama (RU)", modelYear: "Model Yılı", model: "Model", dailyKmLimit: "Günlük km limiti",
      selectBrand: "Marka seçin", selectModel: "Model seçin", chooseBrandFirst: "Önce marka seçin", selectYear: "Yıl seçin",
      edit: "Düzenle", vehicles: "araç", deleteConfirm: "Bu aracı sil?",
      discounts: "Uzun Kiralama İndirimleri", discountsSub: "Uzun kiralamalarda müşteri fiyatına otomatik indirim uygula (maliyet aynı kalır).", minDays: "Min gün", percentOff: "% indirim", addRule: "Kural ekle", saveDiscounts: "İndirimleri kaydet", noDiscounts: "İndirim kuralı yok — tam günlük fiyat uygulanır.",
      topCars: "En Kârlı Araçlar", monthlyTrend: "Aylık Ciro & Kâr", noAnalytics: "Grafik için henüz tamamlanan rezervasyon yok.", discountApplied: "indirim uygulandı",
      downloadPdf: "Teklifi PDF indir",
      sales: "Kesinleşen Satışlar",
      salesCount: "kesinleşen satış",
      addExternalSale: "Dış satış ekle",
      exportSalesExcel: "Excel indir",
      salesExcelReady: "Kesinleşen Satışlar Excel dosyası hazır.",
      entryCost: "Giriş maliyeti",
      salePrice: "Satış fiyatı",
      profit: "Kâr",
      documents: "Dökümanlar",
      uploadDoc: "PDF / görsel yükle",
      noSales: "Henüz kesinleşen satış yok.",
      locked: "Yalnızca yönetici düzenleyebilir",
      editSale: "Satışı düzenle",
      approveTitle: "Satışı kesinleştir",
      approveSub: "Giriş maliyeti ve satış fiyatını girin. Kaydedilen değerleri yalnızca yönetici değiştirebilir.",
      confirmSale: "Satışı kesinleştir",
      externalTag: "Dış",
      requestTag: "Talepten",
      customerName: "Müşteri",
      vehicleName: "Araç",
      saveSale: "Kaydet",
      deleteSaleConfirm: "Bu kesinleşen satış silinsin mi?",
      deleteDocumentConfirm: "Bu belge silinsin mi?",
    },
    legal: {
      privacy: "Gizlilik Politikası",
      rental: "Kiralama Koşulları",
      consentPre: "Okudum ve kabul ediyorum:",
      consentAnd: "ve",
      consentRequired: "Devam etmek için Kiralama Koşulları ve Gizlilik Politikası'nı kabul edin.",
    },
    quick: {
      reserve: "Hızlı Rezervasyon",
      title: "Hızlı rezervasyon",
      start: "Başlangıç tarihi",
      end: "Bitiş tarihi",
      name: "Ad Soyad",
      phone: "Telefon",
      phoneCountry: "Ülke / telefon kodu",
      requestDestination: "Talebiniz yönetim panelindeki Talepler bölümüne düşer.",
      submit: "Talep gönder",
    },
  },
  RU: {
    nav: { fleet: "Автопарк", rental: "Аренда авто", services: "VIP Услуги", how: "Как это работает", about: "О нас", contact: "Контакты", admin: "Админ", allCars: "Все автомобили →", rentPrefix: "Аренда" },
    seo: {
      homeTitle: "Аренда люкс-авто в Дубае | Silver Drive",
      homeDesc: "Арендуйте Ferrari, Lamborghini, Rolls-Royce или Bentley в Dubai. Бесплатная доставка, без депозита, полная страховка и консьерж 24/7. Забронируйте аренду люксового авто за минуты.",
      homeKeywords: "аренда авто дубай, аренда люкс авто дубай, аренда суперкара дубай, аренда экзотических авто дубай, аренда ferrari дубай, аренда lamborghini дубай, аренда rolls royce дубай, аренда bentley дубай",
      heroAlt: "Автопарк люксовых автомобилей Silver Drive в Dubai",
      altSuffix: "в аренду в Dubai",
      carKwTpl: "аренда {name} дубай, {brand} аренда дубай, прокат {name} дубай, аренда люкс авто дубай",
      catKwTpl: "аренда {name} дубай, прокат {name} дубай, аренда люкс {name} дубай, {name} аренда авто дубай",
      detailTitleTpl: "Аренда {name} в Дубае | Silver Drive",
      detailDescTpl: "Арендуйте {name} в Dubai от {price}/день. Бесплатная доставка, без депозита, полная страховка и консьерж 24/7. Бронируйте онлайн с Silver Drive.",
      galleryAltTpl: "{name} — фото {n}, аренда люксовых авто в Dubai",
    },
    hero: {
      eyebrow: "Дубай • Консьерж аренды авто класса ультра-люкс",
      title: "Покорите дорогу в абсолютной роскоши",
      subtitle: "От Ferrari до Rolls-Royce, от Lamborghini до Bentley — Silver Drive доставит самые желанные автомобили мира к вашему порогу в Дубае.",
      exploreFleet: "Смотреть автопарк",
      instantBooking: "Мгновенное бронирование",
      noDeposit: "Без депозита", noDepositSub: "Нулевой залог",
      freeDelivery: "Бесплатная доставка", freeDeliverySub: "По всему Дубаю",
      dreamLine1: "АВТОМОБИЛЬ ВАШЕЙ МЕЧТЫ",
      dreamGold: "В ДУБАЕ",
      dreamLine3: "ЖДЁТ ВАС",
      tagline2: "Арендуй. Веди. Открывай. Не соглашайтесь на обычное — живите незабываемым.",
      bookNow: "ЗАБРОНИРОВАТЬ",
      features: [
        { title: "Премиум автопарк", sub: "Отборные гиперкары" },
        { title: "Без депозита", sub: "Нулевой залог" },
        { title: "Бесплатная доставка", sub: "По всему Дубаю" },
        { title: "Поддержка 24/7", sub: "Всегда рядом" },
        { title: "VIP-опыт", sub: "Безупречный сервис" }
      ],
      stat1: "Гиперкары", stat2: "VIP Консьерж", stat3: "Варианты депозита",
    },
    fleet: {
      title: "Коллекция",
      subtitle: "Тщательно подобранный автопарк гиперкаров, суперкаров и авто класса ультра-люкс.",
      all: "Все", allSuppliers: "Все поставщики", viewAll: "Смотреть все →", perDay: "/ день", viewDetails: "Смотреть & Арендовать", available: "Доступен", booked: "Занят", maintenance: "На обслуживании",
    },
    detail: {
      back: "Назад к автопарку", specifications: "Характеристики", engine: "Двигатель", horsepower: "Мощность",
      acceleration: "0-100 км/ч", topSpeed: "Макс. скорость", transmission: "Коробка передач", seats: "Места", dailyKmLimit: "Дневной лимит пробега",
      dailyRate: "Суточная цена", requestBooking: "Запросить этот автомобиль", startDate: "Дата начала", endDate: "Дата окончания",
      firstName: "Имя", lastName: "Фамилия", phone: "Номер телефона", note: "Примечание (необязательно)",
      submit: "Отправить запрос на бронирование", estimated: "Примерная сумма", days: "дней",
      successTitle: "Запрос получен", successMsg: "Наш VIP-консьерж свяжется с вами в ближайшее время для подтверждения брони.",
      selectDates: "Пожалуйста, выберите даты аренды.", notFound: "Автомобиль не найден.",
      unavailableTitle: "Недоступные даты", datesUnavailable: "Эти даты уже заняты. Пожалуйста, выберите другой период.",
      currentlyBooked: "Сейчас в аренде",
      pickDates: "Выберите даты аренды", clearDates: "Очистить",
      deliveryQuestion: "Как вы хотите получить автомобиль?",
      deliveryOption: "Доставьте мне", pickupOption: "Заберу из вашего офиса",
      deliveryLocation: "Место доставки / отель / адрес", deliveryLocationPh: "напр. Atlantis The Palm, Dubai",
      phonePlaceholder: "50 123 45 67", countryCode: "Страна",
    },
    showcase: [
      { brand: "Lamborghini", model: "Revuelto", tagline: "Для великих путешествий" },
      { brand: "Ferrari", model: "F8 Tributo", tagline: "Страсть на каждой дороге" },
      { brand: "McLaren", model: "720S", tagline: "Где мощь встречает свободу" }
    ],
    home: {
      brandTitle: "По марке",
      brandSub: "Выбирайте среди самых престижных автомобильных марок мира.",
      whatsappCta: "Бронь в WhatsApp",
      aiChatCta: "AI-консьерж",
      featuredTitle: "Хиты недели",
      featuredSubtitle: "Наши самые востребованные автомобили, готовы к немедленной доставке.",
      showMore: "Показать ещё",
      showLess: "Свернуть",
      popularModels: "Популярные модели в аренду в Дубае",
      catTitle: "По категории",
      catSub: "От представительских седанов до экзотических суперкаров — найдите идеальный автомобиль для любого случая.",
      categories: [
        { title: "Люкс седаны", sub: "Rolls-Royce, Bentley, Mercedes-Maybach" },
        { title: "Премиум SUV", sub: "Lamborghini Urus, Range Rover, G63" },
        { title: "Кабриолеты", sub: "Открытый верх для прибрежных дорог" },
        { title: "Спорткары", sub: "Ferrari, McLaren, Porsche" }
      ],
      revTitle: "Что говорят наши гости",
      revSub: "Реальные отзывы клиентов по всему Дубаю и ОАЭ.",
      reviews: [
        { name: "Dave R.", car: "Ferrari F8", text: "Доставили в отель за 30 минут. Команда очень отзывчивая и профессиональная. Настоятельно рекомендую." },
        { name: "Mamadou W.", car: "Range Rover SVR", text: "Невероятный опыт — каждая машина безупречна, мощная и точно как обещали. Доставка и возврат вовремя." },
        { name: "Val M.", car: "Lamborghini Huracan", text: "Пользовался много раз и ни разу не разочаровали. Отличные машины и первоклассный сервис." }
      ],
      whyTitle: "Почему Дубай выбирает Silver Drive",
      why: [
        "Лицензированный оператор аренды люкс-авто в Дубае и ОАЭ",
        "Один из крупнейших парков экзотики — Ferrari, Lamborghini, Rolls-Royce, Bentley",
        "Прозрачные суточные цены без скрытых платежей",
        "Работаем 24/7, мгновенное бронирование и полная страховка",
        "Без вариантов депозита",
        "Бесплатная доставка и возврат по всем Эмиратам"
      ],
      waysTitle: "Способы поездок с Silver Drive",
      ways: [
        "Аренда без водителя на день, неделю или месяц",
        "Услуга с водителем для трансферов и мероприятий",
        "Пакеты для свадеб, фотосессий и корпоративов",
        "Доставка по Дубаю, Абу-Даби, Шардже и Рас-эль-Хайме"
      ],
      stepsTitle: "Как забронировать люкс-авто",
      stepsSub: "Бронирование за минуты — доставка к двери, часто в течение 60 минут.",
      steps: [
        "Просмотрите автопарк и сравните модели, характеристики и цены",
        "Забронируйте за секунды через форму",
        "Предоставьте действующие права и Emirates ID или паспорт",
        "Выберите доставку в отель, резиденцию или любой аэропорт ОАЭ",
        "Получите автомобиль, часто в течение 60 минут"
      ],
      faqTitle: "Часто задаваемые вопросы",
      faq: [
        { q: "Как арендовать авто в Дубае туристу?", a: "Выберите автомобиль и даты, затем отправьте запрос. Мы подтвердим наличие, итоговую стоимость и нужные документы, затем бесплатно доставим в отель или любой аэропорт ОАЭ — обычно в течение 60 минут." },
        { q: "Какие документы нужны?", a: "Действующие права, принимаемые в ОАЭ, копия паспорта и кредитная карта. Резиденты ОАЭ могут предоставить Emirates ID; некоторым туристам нужно международное водительское удостоверение." },
        { q: "Нужен ли залог?", a: "Доступна аренда без залога." },
        { q: "Есть ли ограничения по возрасту?", a: "Водителям должно быть не менее 21 года для большинства люкс-авто и 25+ для отдельных суперкаров. Мы подтверждаем право при бронировании." },
        { q: "Доставляете в отели и аэропорт?", a: "Да — бесплатная доставка и возврат по всему Дубаю, включая крупные отели, Dubai Marina, Downtown и оба аэропорта, 24/7." }
      ]
    },
    footer: { tagline: "Ведущее ателье аренды авто класса ультра-люкс в Дубае.", rights: "Все права защищены.", address: "Sheikh Zayed Road, Dubai, UAE", concierge: "VIP Консьерж 24/7", deliveryNote: "Доставка по Дубаю, Абу-Даби и Эмиратам." },
    lead: {
      title: "Перезвоним вам", sub: "Оставьте номер — перезвоним в течение минут с лучшей ценой.",
      call: "Звонок", callMe: "Перезвоните мне", namePh: "Ваше имя", phonePh: "Ваш телефон",
      success: "Спасибо! Наша команда скоро перезвонит вам.", validate: "Введите имя и телефон", got: "Готово! Мы скоро перезвоним.",
    },
    category: {
      popularTitle: "Популярные категории",
      popularSub: "Найдите идеальный автомобиль по категории — от гоночной экзотики до внушительных люкс-внедорожников.",
      explore: "Смотреть",
      available: "в аренду в Дубае",
      faqTitle: "Часто задаваемые вопросы",
      reserve: "Забронируйте {name} сегодня",
      reserveSub: "Бесплатная доставка по Дубаю • Без депозита • Консьерж 24/7",
      ratesFrom: "Цены от",
      perDay: "/день",
      emptyMsg: "Новые {name} скоро появятся. Свяжитесь с консьержем для актуального наличия.",
      benefits: ["Бесплатная доставка по Дубаю", "Без наличного депозита", "Полная страховка включена", "Поддержка консьержа 24/7", "Гибкие суточные, недельные и месячные тарифы"],
      faqs: [
        { q: "Сколько стоит аренда {name} в Дубае?", a: "Аренда с Silver Drive начинается от AED {price} в сутки, со скидками на неделю и месяц. Каждая цена включает полную страховку и бесплатную доставку по Дубаю." },
        { q: "Нужен ли залог?", a: "Наличный депозит не требуется. Мы делаем только полностью возвратную преавторизацию на вашей карте на срок аренды." },
        { q: "Доставите авто в отель или аэропорт?", a: "Да — Silver Drive предлагает бесплатную доставку и возврат в любую точку Дубая 24/7, включая все аэропорты ОАЭ." },
        { q: "Какие документы нужны?", a: "Резидентам ОАЭ нужны действующие права ОАЭ и Emirates ID. Туристам — паспорт, права своей страны и международное водительское удостоверение." },
        { q: "Можно арендовать на более долгий срок?", a: "Конечно. Мы предлагаем гибкие суточные, недельные и месячные тарифы — чем дольше аренда, тем ниже суточная цена. Спросите консьержа." },
      ],
    },
    admin: {
      login: "Вход для админа", email: "Эл. почта", password: "Пароль", signIn: "Войти",
      dashboard: "Панель", cars: "Автопарк", requests: "Запросы", settings: "Настройки", logout: "Выход",
      totalRequests: "Всего запросов", fleetCount: "Автомобилей", activeRentals: "Активные аренды",
      revenue: "Завершённый доход", newRequests: "Новые запросы",
      revenueLabel: "Выручка", costLabel: "Затраты", profitLabel: "Прибыль", margin: "Маржа",
      allReservations: "Все брони", completedReservations: "Завершённые брони",
      cost: "Себестоимость / день (AED)", profitPerDay: "Прибыль / день", calendarTitle: "Календарь доступности",
      bookedDay: "Занято", freeDay: "Свободно", noFinance: "Пока нет завершённых броней.",
      addCar: "Добавить авто", editCar: "Редактировать авто", deleteCar: "Удалить", save: "Сохранить", cancel: "Отмена",
      name: "Название", brand: "Марка", category: "Категория", status: "Статус", source: "Поставщик", price: "Суточная цена (AED)",
      customer: "Клиент", vehicle: "Автомобиль", dates: "Даты", total: "Итого", actions: "Действия",
      noRequests: "Пока нет запросов на бронирование.",
      availability: "Доступность", manageAvailability: "Управление доступностью",
      selectVehicle: "Выберите авто для управления занятыми датами.",
      busyPeriods: "Занятые периоды", addPeriod: "Отметить как занято",
      noPeriods: "Нет занятых периодов. Автомобиль полностью доступен.",
      from: "С", to: "По", labelField: "Метка (напр. имя клиента)",
      blockDates: "Заблокировать даты", availableNow: "Доступен", bookedNow: "Занят",
      engine: "Двигатель", horsepower: "Мощность", acceleration: "0-100 км/ч", topSpeed: "Макс. скорость", transmission: "Коробка", seats: "Места",
      mainImage: "Главное фото", changeMainImage: "Изменить главное фото", selectMainImage: "Выбрать главное фото", pleaseMainImage: "Загрузите главное фото",
      galleryImages: "Галерея", addGalleryImages: "Добавить фото в галерею", uploading: "Загрузка…",
      descEn: "Описание (EN)", descTr: "Описание (TR)", descRu: "Описание (RU)", modelYear: "Год модели", model: "Модель", dailyKmLimit: "Дневной лимит км",
      selectBrand: "Выберите марку", selectModel: "Выберите модель", chooseBrandFirst: "Сначала выберите марку", selectYear: "Выберите год",
      edit: "Изменить", vehicles: "авто", deleteConfirm: "Удалить этот автомобиль?",
      discounts: "Скидки за долгую аренду", discountsSub: "Автоскидка на цену клиента при долгой аренде (себестоимость не меняется).", minDays: "Мин. дней", percentOff: "% скидки", addRule: "Добавить правило", saveDiscounts: "Сохранить скидки", noDiscounts: "Нет правил скидок — действует полная суточная цена.",
      topCars: "Самые прибыльные авто", monthlyTrend: "Выручка и прибыль по месяцам", noAnalytics: "Пока нет завершённых броней для графика.", discountApplied: "скидка применена",
      downloadPdf: "Скачать предложение (PDF)",
      sales: "Подтверждённые продажи",
      salesCount: "подтверждённых продаж",
      addExternalSale: "Добавить внешнюю продажу",
      exportSalesExcel: "Скачать Excel",
      salesExcelReady: "Excel-файл подтверждённых продаж готов.",
      entryCost: "Входная стоимость",
      salePrice: "Цена продажи",
      profit: "Прибыль",
      documents: "Документы",
      uploadDoc: "Загрузить PDF / изображение",
      noSales: "Пока нет подтверждённых продаж.",
      locked: "Изменения только для администратора",
      editSale: "Изменить продажу",
      approveTitle: "Подтвердить продажу",
      approveSub: "Укажите входную стоимость и цену продажи. Изменять сохранённые значения может только администратор.",
      confirmSale: "Подтвердить продажу",
      externalTag: "Внешняя",
      requestTag: "Из запроса",
      customerName: "Клиент",
      vehicleName: "Автомобиль",
      saveSale: "Сохранить",
      deleteSaleConfirm: "Удалить эту подтверждённую продажу?",
      deleteDocumentConfirm: "Удалить этот документ?",
    },
    legal: {
      privacy: "Политика конфиденциальности",
      rental: "Условия аренды",
      consentPre: "Я прочитал(а) и принимаю",
      consentAnd: "и",
      consentRequired: "Примите Условия аренды и Политику конфиденциальности, чтобы продолжить.",
    },
    quick: {
      reserve: "Быстрая бронь",
      title: "Быстрое бронирование",
      start: "Дата начала",
      end: "Дата окончания",
      name: "Имя и фамилия",
      phone: "Телефон",
      phoneCountry: "Страна / код телефона",
      requestDestination: "Ваш запрос поступит в раздел «Запросы» панели управления.",
      submit: "Отправить запрос",
    },
  },
};

export const NO_DEPOSIT_OPTION = "No Deposit Option";

const DEPOSIT_COPY_PATTERN = /no[-\s]?deposit options?|zero security deposit|no cash deposit is required|no cash deposit required|no cash deposit|security deposit|deposit options?|deposit|depozitosuz seçenekler|depozito seçeneği yok|sıfır güvence bedeli|nakit depozito gerekmez|depozitosuz|depozito yok|depozito gerekiyor mu|depozito gerekli mi|depozito|без наличного депозита|без депозита|нулевой залог|варианты депозита|депозит[а-я]*/gi;

export const normalizeNoDepositText = (value) => {
  if (typeof value === "string") {
    return value.replace(DEPOSIT_COPY_PATTERN, NO_DEPOSIT_OPTION);
  }

  if (Array.isArray(value)) {
    return value.map(normalizeNoDepositText);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, normalizeNoDepositText(item)]),
    );
  }

  return value;
};

export const translations = normalizeNoDepositText(rawTranslations);

export const CATEGORIES = ["All", "Supercar", "Luxury SUV", "Convertible", "Grand Tourer"];
